<div class="container-fluid container-fluid--dashboard">
  <div class="d-flex flex-row flex-no-wrap">
    <ng-container *ngIf="!isConversation">
      <div class="flex-shrink-0" style="padding-top: 10px" [style.width.px]="role == Roles.CorporateHR || role == Roles.LocalHR ? 340 : 250" *ngIf="role != Roles.Employee">
        <iframe #employeeListIframe *ngIf="initialised && employeelistIframe" id="tab-personnel" frameborder="0" width="100%" height="100%" [src]="employeelistIframe"> Je browser ondersteunt geen iframes... </iframe>
      </div>
    </ng-container>
    <div class="flex-grow-1">
      <ng-container *ngIf="studentId">
        <div class="h2-content mt-0">
          <h2 class="mt-0 pt-1 mb-3 d-flex align-items-center gap-3" *ngIf="student">
            <app-profile-picture style="padding-top: 5px" [whoId]="student.id" [whoKind]="3" [text]="student.firstName + ' ' + student.lastName" [width]="40"></app-profile-picture>
            <div>
              <div style="line-height: 25px">{{ student.firstName }} {{ student.lastName }}</div>
              <p class="mb-0">{{ student.function?.name }} - {{ student.department?.name }}</p>
            </div>
          </h2>

          <div *ngIf="level1Tabs && level1Tabs.length">
            <div class="tabs-wrapper">
              <!-- Level 1 tabs -->
              <ul ngbNav #navTabs1="ngbNav" [(activeId)]="activeLevel1Id" class="main-tabs nav-tabs">
                <li *ngFor="let tab of level1Tabs; trackBy: trackTabs" [ngbNavItem]="tab.id" (click)="selectLevel1(tab)">
                  <a ngbNavLink [title]="tab.label">{{ tab.label }}</a>
                </li>
              </ul>

              <div class="level1-panel">
                <!-- Level 2 tabs -->
                <ng-container *ngIf="level2Tabs.length > 0">
                  <ul ngbNav #navTabs2="ngbNav" [(activeId)]="activeLevel2Id" class="main-tabs nav-tabs">
                    <li *ngFor="let tab of level2Tabs; trackBy: trackTabs" [ngbNavItem]="tab.id" (click)="selectLevel2(tab)">
                      <a ngbNavLink [title]="tab.label">{{ tab.label }}</a>
                    </li>
                  </ul>
                </ng-container>

                <div class="level2-panel" *ngIf="level2Tabs.length > 0">
                  <!-- Level 3 tabs -->
                  <ng-container *ngIf="level3Tabs.length > 0">
                    <ul ngbNav #navTabs3="ngbNav" [(activeId)]="activeLevel3Id" class="main-tabs nav-tabs">
                      <li *ngFor="let tab of level3Tabs; trackBy: trackTabs" [ngbNavItem]="tab.id" (click)="selectLevel3(tab)">
                        <a ngbNavLink [title]="tab.label">{{ tab.label }}</a>
                      </li>
                    </ul>
                  </ng-container>

                  <!-- iframe -->
                  <div #contentframe id="tab-iframe-wrapper" *ngIf="iframelinkSafe && !shownTab.customFieldTab">
                    <iframe id="tab-frame" #iframe frameborder="0" width="100%" height="100%" [src]="iframelinkSafe" (load)="onIframeLoad()"> </iframe>
                    <ng-container *ngTemplateOutlet="contentLoader"></ng-container>
                  </div>
                  <div #contentframe id="tab-iframe-wrapper" *ngIf="shownTab && shownTab.customFieldTab">
                    <app-custom-field-content [tabId]="shownTab.customFieldTab.customFieldTabId" [employeeId]="studentId"></app-custom-field-content>
                  </div>
                </div>

                <!-- iframe directly under level1 when no level2 exists -->
                <div #contentframe id="tab-iframe-wrapper" *ngIf="!level2Tabs.length && iframelinkSafe && !shownTab.customFieldTab">
                  <iframe id="tab-frame" #iframe frameborder="0" width="100%" height="100%" [src]="iframelinkSafe" (load)="onIframeLoad()"> </iframe>
                  <ng-container *ngTemplateOutlet="contentLoader"></ng-container>
                </div>
                <div #contentframe id="tab-iframe-wrapper" *ngIf="!level2Tabs.length && iframelinkSafe && shownTab?.customFieldTab">
                  <app-custom-field-content [tabId]="shownTab.customFieldTab.customFieldTabId" [employeeId]="studentId"></app-custom-field-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #contentLoader>
  <div class="tab-content-loader" *ngIf="loading">
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHRSURBVEhLYxjygBFKEwW2vHz2v+n2NYanP74zaPHwMfiISzKES8oySHBw4jSHKAte/Pj+v/bWVYbZj+5BRRBAmoOToV5ViyFNXhmrWQQtmPXw7v9GqKvxgQJFVYYJ2oYY5uG04PzH9//Lrl9i2P3mJVSEMGhW12GoVdVCMRPDgq9//vxvv3uDoe/eTYZvf/9CRYkDLIyMDKdtXBgM+QXh5jJBaTAARaL50b0MLcAgIdVwEPjz/z9D250bUB4EwC2ouXnlv8/pIwxXPn+EipAH9gCDFJQooFyEBfMf34eyKAPvf/9iuPn1C5SHZAE5QYILPPz+FcpCiwNaALgFXMzMUBblQIiVDcpCsgCUI6kBmIFJVZGLG8pDssBNVALKogxoAssoZS4eKA/JggQZeaoEU56CCgMHMzNmRlPh5mWsVNGE8sgDZgJCDHEyClAeBMAtAIEaZXWGUGDxSw4AxeF8fVMU14MAigWMTMyMiw3MGFLllKAixAGQy3eZ2zFo8/JjlG0YAjAAKpcm3r/NcPDda4Zf//5BRVGBDi8/0DGKDCmySgzcLCxYzcJpAQxc/fzx/9mP7xluAbP/lz+/wWKgZGjAJ8hgDnQ5epCMAhIBAwMAkZCFkdRkDGMAAAAASUVORK5CYII="
      class="fa-spin"
      alt=""
    />
  </div>
</ng-template>
